import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Portal } from "./Portal";
import { TeambookIcon } from "../../default_images/TeambookIcon";
import { icons } from "../../default_images/IconsList";
import Api from "../../../Api";
import { useBookingsStore, useCopyBookingsStore, useZoomStore } from "../../../stores/planner";
import { shallow } from "zustand/shallow";
import { DateTime } from "luxon";
import bookingPrecheckModal from "../../default_components/question_modals/bookingPrecheckModal";
import {OffsetDays} from "../../../lib/DateUtils";

const PlannerRightClick = React.forwardRef(({ plannerDispatcher, usersRef, teams }, ref) => {
  const [open, setOpen] = useState(false);
  const [posX, setPosX] = useState(null);
  const [posY, setPosY] = useState(null);
  const screenSize = document.body.clientWidth;
  const [copyUserId, setCopyUserId] = useState(null);
  const [copyDate, setCopyDate] = useState(null);
  const [copyUserIndex, setCopyUserIndex] = useState(null);
  const { t } = useTranslation();

  const [zoom] = useZoomStore((state) => [state.zoom], shallow);

  const [bookings, setBookings] = useBookingsStore((state) => [state.bookings, state.setBookings], shallow);

  React.useImperativeHandle(ref, () => {
    return {
      open: open,
      setOpen: setOpen,
      setPosX: setPosX,
      setPosY: setPosY,
      setCopyUserId: setCopyUserId,
      setCopyDate: setCopyDate,
      setCopyUserIndex: setCopyUserIndex,
    };
  });

  const closeMenu = () => {
    setOpen(false);
  };

  async function onCopyOptionClickHandler() {
    const bookingsToMove = bookings.filter(booking => useCopyBookingsStore.getState().copyBookingIds.includes(booking.id));

    const firstBooking = bookingsToMove.sort((a, b) => new Date(a.date) - new Date(b.date))[0];
    const dateOffset = DateTime.fromJSDate(copyDate).diff(DateTime.fromISO(firstBooking.date), 'days').as('days');

    const bookingsToBeCopied = bookingsToMove.map(booking => ({
      id: 0,
      date: DateTime.fromISO(booking.date).plus({ days: dateOffset }).toISODate(),
      user_id: copyUserId,
      grouping_id: booking.grouping_id,
      project_id: booking.project_id,
    }))

    const precheckResult = await bookingPrecheckModal(bookingsToBeCopied, t);

    if (precheckResult === "skip") {
      return [];
    }

    Api.Administrators.post_some_statistics(`booking_copied_right_click`);

    finishCopyBooking(posX, posY);
    setOpen(false);
  }

  const finishCopyBooking = () => {
    Api.Bookings.copy(
      useCopyBookingsStore.getState().copyBookingIds,
      copyUserId,
      DateTime.fromJSDate(copyDate).toFormat("dd-MM-yyyy")
    )
      .then((response) => {
        setBookings([...bookings, ...response.data]);

        plannerDispatcher.afterCreationBookingAssignment([copyUserIndex]);
      })
      .catch((e) => console.log(e));
  };

  return (
    open &&
    zoom !== 1 && (
      <>
        <Portal onClick={closeMenu} />

        <div
          className="planner__context-menu"
          style={{
            left: posX > screenSize - 130 ? posX - 130 : posX,
            top: posY,
          }}
        >
          <div className="planner__context-menu-option" style={{ borderRadius: 10 }} onClick={onCopyOptionClickHandler}>
            <TeambookIcon style={{ width: 18, height: 18 }} name={icons.COPY} />
            <p>{t("paste")}</p>
          </div>
        </div>
      </>
    )
  );
});

PlannerRightClick.displayName = "PlannerRightClick";

export default PlannerRightClick;
